module.exports = __webpack_public_path__ + "22c8f9a6e4fbdb1136a629e369ad605e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-bow.png
// module id = 2036
// module chunks = 4